import { Dispatch } from 'redux'
import { getFMCSA } from 'utils/actions/carrier'
import { ENDPOINTS } from 'utils/api/callApi'
import { checkCompliance } from 'apps/booking/utils/actions/options'

export enum FETCH_CARRIER_ACTION_TYPES {
  FETCH_CARRIER_REQUEST = 'FETCH_CARRIER_REQUEST',
  FETCH_CARRIER_SUCCESS = 'FETCH_CARRIER_SUCCESS',
  FETCH_CARRIER_FAILURE = 'FETCH_CARRIER_FAILURE',
}

export enum CARRIER_ACTIONS {
  CLEAR_CARRIER_DATA = 'CLEAR_CARRIER_DATA',
}

export const fetchCarrier = (id: string) => {
  const requestData = {
    endpoint: ENDPOINTS.carriers,
    id,
    method: 'GET',
  }

  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(FETCH_CARRIER_ACTION_TYPES),
    },
  }
}

export const getCarrierInfo = (carrierId: string, shipmentId?: number) => (
  // TODO: TO-TYPE - callApi fn
  // https://transfix.atlassian.net/browse/FE-110
  dispatch: Dispatch<any>
) => {
  dispatch(fetchCarrier(carrierId))
  dispatch(getFMCSA(carrierId))
  dispatch(checkCompliance({ carrierId, shipmentId }))
}

export const clearCarrier = () => ({ type: CARRIER_ACTIONS.CLEAR_CARRIER_DATA })
